// extracted by mini-css-extract-plugin
export default {"buttons":"TabButtons_buttons__HZWwj","active":"TabButtons_active__avEmn"};